var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.202 24C9.89894 24 9.69692 23.9 9.4949 23.7L3.4343 17.6L3.33329 17.5C3.23228 17.4 3.13127 17.3 3.03026 17.2C-0.909136 13.2 -1.01015 6.8 2.82824 2.9C4.64642 1 7.07066 0 9.59591 0C12.3232 0 14.9495 1.1 16.8686 3.1C20.808 7.1 20.909 13.5 17.0707 17.4C16.9697 17.5 16.8686 17.6 16.7676 17.7L16.6666 17.8L10.909 23.7C10.707 23.9 10.505 24 10.202 24ZM5.05046 16.3L10.202 21.5L15.1515 16.5C15.1515 16.4 15.2525 16.3 15.3535 16.3L15.4545 16.2C15.5555 16.1 15.6565 16 15.7575 15.9C18.7878 12.8 18.6868 7.6 15.5555 4.4C13.9393 2.9 11.8181 2 9.59591 2C7.57571 2 5.65652 2.8 4.24238 4.2C1.21208 7.3 1.31309 12.5 4.4444 15.7C4.54541 15.8 4.64642 15.9 4.74743 16L4.84844 16.1C4.94945 16.2 5.05046 16.3 5.05046 16.3ZM9.99995 14C7.77773 14 5.95955 12.2 5.95955 10C5.95955 7.8 7.77773 6 9.99995 6C12.2222 6 14.0404 7.8 14.0404 10C14.0404 12.2 12.2222 14 9.99995 14ZM9.99995 8C8.88884 8 7.97975 8.9 7.97975 10C7.97975 11.1 8.88884 12 9.99995 12C11.1111 12 12.0202 11.1 12.0202 10C12.0202 8.9 11.1111 8 9.99995 8Z",
    fill: "#2C94AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.a067002ac25c6be7001081b677d729ec.svg";
export { ForwardRef as ReactComponent };